import { movies, type Movie } from '@/mocks/movies';

export const getMovieById = (id: string): Movie | undefined =>
  movies.find((m) => m.id === id);

export const getFeaturedMovies = (): Movie[] => movies.filter((m) => m.featured);

export const formatViews = (views: number): string => {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
};

export interface MovieFilter {
  q?: string;
  type?: string;
  genre?: string;
  region?: string;
  year?: string;
}

export const filterMovies = (list: Movie[], filter: MovieFilter): Movie[] => {
  const keyword = (filter.q || '').trim().toLowerCase();
  return list.filter((m) => {
    if (keyword) {
      const haystack = `${m.title} ${m.genre} ${m.type} ${m.tags.join(' ')} ${m.summary}`.toLowerCase();
      if (!haystack.includes(keyword)) return false;
    }
    if (filter.type && filter.type !== '全部' && m.type !== filter.type) return false;
    if (filter.genre && filter.genre !== '全部' && m.genre !== filter.genre) return false;
    if (filter.region && filter.region !== '全部' && m.region !== filter.region) return false;
    if (filter.year && filter.year !== '全部' && String(m.year) !== filter.year) return false;
    return true;
  });
};

export type SortKey = 'updated' | 'hot' | 'year';

export const sortMovies = (list: Movie[], sortKey: SortKey): Movie[] => {
  const copy = [...list];
  if (sortKey === 'hot') {
    return copy.sort((a, b) => b.views - a.views);
  }
  if (sortKey === 'year') {
    return copy.sort((a, b) => b.year - a.year);
  }
  return copy.sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
};

export const getRelatedMovies = (movie: Movie, count = 4): Movie[] => {
  const scored = movies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      let score = 0;
      if (m.type === movie.type) score += 2;
      if (m.genre === movie.genre) score += 3;
      if (m.region === movie.region) score += 1;
      movie.tags.forEach((t) => {
        if (m.tags.includes(t)) score += 2;
      });
      return { movie: m, score };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, count).map((s) => s.movie);
};

export const getMoviesByIds = (ids: string[]): Movie[] =>
  ids.map((id) => movies.find((m) => m.id === id)).filter((m): m is Movie => Boolean(m));